import { useAuth } from "../contexts/AuthContext"
import { useMisc } from "../contexts/MiscContext";
import { getCustomClaim } from "../scripts/Misc";
import "../styles/Profile.scss";
import { useLocation } from "react-router-dom";
import CLink from "../components/CLink";
import { IoIosStar } from "react-icons/io";

import headshot from "../assets/headshot_gen_neutral.png"

import { lightenColor } from "../scripts/Misc";
import { toast } from "react-toastify";

const badges = [
    {
        name: "Beginner",
        icon: "https://via.placeholder.com/15",
        color: "#0e7d10"
    },
    // {
    //     name: "Master",
    //     icon: "https://via.placeholder.com/15",
    //     color: "#16548e"
    // },
    // {
    //     name: "Advanced",
    //     icon: "https://via.placeholder.com/15",
    //     color: "#ba3535"
    // },
    // {
    //     name: "God",
    //     icon: "https://via.placeholder.com/15",
    //     color: "#b05411"
    // },
    // {
    //     name: "Sabz",
    //     icon: "https://via.placeholder.com/3",
    //     color: "#a311b0"
    // }
]

export default function Profile() {

    const {USER_PRESENT, currentUser, userJson, signout, signinwithpopup, SEND_EMAIL_FOR_VERIFICATION } = useAuth();
    const { toTitleCase } = useMisc();

    const location = useLocation()

    const sendEmailVerification = () => {
        SEND_EMAIL_FOR_VERIFICATION()
        .then((res) => {
            console.log(res);
            toast.info(`An email has been sent to ${currentUser.email} containing the verification link.`);
        })
        .catch((err) => {
            console.error(err);
            toast.error("An error occurred while sending the email verification link.");
        })
    }

    const getPreviousPageName = (prevPath) => {
        if (prevPath) {
            const pathList = prevPath.split("/")
            return toTitleCase( pathList.at( pathList.length - 1 ) );
        }
        else {
            return null;
        }
    }

    return (
        <section className="profile">
            <div className="previewContainer">
                <div className="previewBox">

                    {
                        (USER_PRESENT()) ? (
                            <div className="previewWrapper">
                                <div className="imageContainer" onDoubleClick={() => console.log(userJson)}>
                                    <img src={currentUser?.photoURL || headshot} referrerPolicy="no-referrer" alt="user's profile image" />
                                </div>
                                <div className="previewDetails">
                                    <div className="detailsWrapper">
                                        <div className="nameAndUsername">
                                            <span className="name" onClick={() => console.log(userJson)}> { userJson?.displayName || "Tyler Durden" }  </span>
                                            <span 
                                                className="username" 
                                                // onClick={() => console.log(currentUser)}
                                                onDoubleClick={async () => {
                                                    console.log(
                                                        await getCustomClaim(currentUser, "username")
                                                    )
                                                }}
                                            >({ `@${userJson?.username}` || '' })</span>
                                        </div>
                                        <div className="about">
                                            Everything is a copy of a copy of a copy. Without pain, without sacrifice, we would be nothing. The first soap was made from the ashes of heroes. The things you own, end up owning you.
                                            {/* <button onClick={sendEmailVerification}>Send email verification.</button> */}
                                        </div>
                                        <div className="badgesContainer">
                                            {
                                            badges.map((badge, index) => {
                                                return (
                                                    <CLink to={`/badges/${badge.name}`} className="badge" style={ { "--badgeColor": badge.color, "--badgeColorHover": lightenColor(badge.color, 0.2) } } key={index}>
                                                        {/* <img src={badge.icon} alt={badge.name} /> */}
                                                        <span className="icon">
                                                            <IoIosStar size={"15px"} className="star"/>
                                                        </span>
                                                        <span className="name">{badge.name}</span>
                                                    </CLink>
                                                )
                                            })
                                            }
                                        </div>
                                        <div className="about">
                                            🚀 Joined {userJson?.createdAt || "---"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="loggedout">
                                Logged out. <CLink to={"/login"}>Log In</CLink> to continue.
                            </div>
                        )
                    }
                </div>
            </div>
            {
                (USER_PRESENT()) && (
                    <button onClick={signout}>Log out</button>
                )
            }

        </section>
    )
}